import { SiteSettings } from "@/sanity/types";

export const defaultSiteSettings: SiteSettings = {
  _createdAt: "",
  _id: "",
  _rev: "",
  _type: "siteSettings",
  _updatedAt: "",
  faq_page_visible: true,
};
